import { GraphQLQuery } from "@aws-amplify/api"
import { useQuery } from "@tanstack/react-query"
import { API } from "aws-amplify"
import { FC } from "react"
import { Link } from "react-router-dom"
import { Button, Container, List, Loader } from "semantic-ui-react"
import { ListProductsQuery } from "../API"
import { listProducts } from "../graphql/queries"
import { NavBar } from "./NavBar"

export function useProducts() {
    return useQuery({
        queryKey: ['products'],
        queryFn: async () => {
            const resp = (await API.graphql<GraphQLQuery<ListProductsQuery>>({
                query: listProducts
            })).data?.listProducts;
            if (resp?.statusCode === 200) {
                return JSON.parse(resp?.body || '[]');
            } else {
                throw new Error(`Failed to list products: ${resp?.statusCode}`);
            }
        }
    });
}

export const Products: FC = () => {
    const {isLoading, data} = useProducts();
    console.log(isLoading);
    if (isLoading) {
        return (
            <Container>
                <NavBar />
                <h1>Products</h1>
                <Loader active inline='centered' />
            </Container>
        )
    }
    return (
        <Container>
            <NavBar />
            <h1>Products</h1>
            <List>
                {data.map((product: any) => (
                    <List.Item key={product.id}>
                        <List.Content>
                            <List.Header>{product.name}</List.Header>
                            <Link to={`/checkout/pay/${product.id}`}>
                                <Button primary>Buy</Button>
                            </Link>
                        </List.Content>
                    </List.Item>
                ))}
            </List>
        </Container>
    )
}